export const SMALL_TEXT_LENGTH = 35;
export const CELL_HEIGHT = 32;
